<my-component>
  <p>{ props.message }</p>
</my-component>
